import { render, staticRenderFns } from "./associate-product-batch-modal.vue?vue&type=template&id=496ff108&"
import script from "./associate-product-batch-modal.vue?vue&type=script&lang=js&"
export * from "./associate-product-batch-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "associate-product-batch-modal.vue"
export default component.exports